var entryContent = document.querySelector('.entry-content');
if (entryContent && entryContent.innerHTML.trim() === '') {
	entryContent.style.display = 'none';
}